export interface ApiErrorShape { code: string; message: string; requestId?: string; details?: unknown }

export class ApiError extends Error {
  constructor(readonly status: number, readonly payload: ApiErrorShape) { super(payload.message); }
}

let csrfToken = "";
export function setCsrfToken(value: string): void { csrfToken = value; }

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = init.method?.toUpperCase() ?? "GET";
  const response = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: {
      accept: "application/json",
      ...(init.body ? { "content-type": "application/json" } : {}),
      ...(!["GET", "HEAD", "OPTIONS"].includes(method) && csrfToken ? { "x-csrf-token": csrfToken } : {}),
      ...init.headers,
    },
  });
  const body = await response.json() as { ok: boolean; data?: T; error?: ApiErrorShape };
  if (!response.ok || !body.ok || body.data === undefined) {
    throw new ApiError(response.status, body.error ?? { code: "UNKNOWN", message: `Request failed (${response.status})` });
  }
  return body.data;
}

export function jsonBody(value: unknown): Pick<RequestInit, "body"> { return { body: JSON.stringify(value) }; }

